<!--
 * @Description: 嘉宾详情H5
 * @Author:  单珊珊
 * @Date: 2024-07-31 10:37:15
 * @LastEditTime: 2024-09-10 11:46:04
 * @LastEditors:  
-->
<template>
  <div class="mobile-container">
    <page-header>{{'嘉宾详情' | dealLanguage('Guest situation')}}</page-header>
    <div class="speaker-detail">
      <div class="guest-img">
        <div class="guest-photo">
          <img :src="guestInfo.logoUrl | logo_show" />
        </div>
        <!-- <div class="comp-logo">
          <img src="https://cdn.vbdata.cn/upload/entity/98e1dc77838bd21fe216a95ffb30e17084.PNG" />
        </div> -->
      </div>
      <div class="guest-info">
        <div class="guest-name"><span></span>{{guestInfo.name | dealLanguage(guestInfo.enName)}}</div>
        <div class="guest-title" v-html="filter.dealLanguage(guestInfo.companyPosition, guestInfo.enCompanyPosition)"></div>
        <div class="guest-desc" v-html="filter.dealLanguage(guestInfo.desc, guestInfo.enDesc)"></div>
      </div>
    </div>
    <div class="froum-wrapper" v-for="item in froum_list" :title="item.activityName" :key="item.activityId">
      <div class="froum-base">
        <p>{{item.dateName}}-{{item.activityName}}</p>
        <p class="location"><i class="iconfont">&#xe672;</i>{{item.forumPlace}}</p>
      </div>
      <div class="agenda-item" v-for="(aitem, gindex) in item.agendas" :key="gindex">
        <div class="forum-title">
          <span class="time">{{aitem.agendaStartTime | time_moment('HH:SS')}}</span>
          <span class="title">{{aitem.agendaTitle}}</span>
        </div>
        <div class="froum-speakers">
          <div class="froum-speakers-item" v-for="(gitem, gindex) in aitem.guests" :key="gindex">
            <div class="speaker-img" @click="goGuestDetail(gitem.id)">
              <div class="photo">
                <img :src="gitem.logoUrl | logo_show" />
              </div>
              <!-- <div class="logo">
                <img src="https://cdn.vbdata.cn/upload/entity/98e1dc77838bd21fe216a95ffb30e17084.PNG" />
              </div> -->
            </div>
            <div class="speaker-info">
              <div class="speaker-name" @click="goGuestDetail(gitem.id)">
                <span></span>
                {{gitem.name | dealLanguage(gitem.enName)}}
              </div>
              <div class="speaker-title">{{gitem.companyPosition | dealLanguage(gitem.enCompanyPosition)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getGuestDetail } from '@/service/vbef'
import PageHeader from '@/components/mobile/pageHeader.vue'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: this.language == 'zh' ? '嘉宾详情' : 'Guest situation', 
    }
  },
  inject: ['wxShare', 'globalInsertRecords'],
  data() {
    return {
      filter,
      guestInfo: '',
      froum_list: [],
    }
  },

  components: {
    PageHeader,
  },

  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      vbef_path: (state) => state.vbef_path,
      user_key: (state) => state.user_key,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
    }),
  },

  created() {
    this.getGuestDetail()
  },

  mounted() {
    this.wxShare({
      title: filter.dealLanguage('嘉宾详情-CSGCT', 'Guest situation-CSGCT'),
      linkurl: this.vbef_path + '/guestInfo/' + this.$route.params.id,
      
    })
  },

  methods: {
    async getGuestDetail() {
      let res = await getGuestDetail({
        guestId: this.$route.params.id,
        actId: this.activityId,
        languageType: this.language == 'zh' ? 0 : 1
      })
      if (res.code == 0) {
        this.$set(this.$data, 'guestInfo', res.data.guestDto)
        this.$set(this.$data, 'froum_list', res.data.activities)
        this.froum_list.map((a) => {
          if (a.forumPlaceJson) {
            let place = JSON.parse(a.forumPlaceJson)
            let forum = ''
            if (place.level1_show == 1 && place.place_level1) forum += place.place_level1
            if (place.level2_show == 1 && place.place_level2) forum += ' ' + place.place_level2
            if (place.level3_show == 1 && place.place_level3) forum += ' ' + place.place_level3
            this.$set(a, 'forumPlace', forum)
          } else {
            this.$set(a, 'forumPlace', '')
          }
        })
      } else {
        this.$Messager.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
    goGuestDetail(guest_id) {
      this.globalInsertRecords({
        contentId: guest_id,
        contentType: 152,
        viewType: 1
      })
      this.$router.push({
        name: 'guestInfo',
        params: {
          id: guest_id,
        },
      })
    },
  },
  watch: {
    '$route.params.id'(newValue) {
      this.getGuestDetail()
    },
  }
}
</script>
<style lang='stylus' scoped>
@import '~styles/forum-list-m.styl'
.mobile-container
  .speaker-detail
    display flex
    padding 0.2rem 0.4rem
    .guest-img
      max-width 2.3rem
      min-width 2.3rem
      width 2.3rem
      height 2.3rem
      position relative
      .guest-photo
        widows 100%
        height 100%
        img
          height 100%
          width 100%
          object-fit cover
      .comp-logo
        width 0.8rem
        height 0.8rem
        background #FFFFFF
        box-shadow 0px 0.03rem 0.08rem 0px rgba(0, 0, 0, 0.16)
        position absolute
        right -0.2rem
        bottom -0.2rem
        img
          max-width 100%
          max-height 100%
    .guest-info
      padding-left 0.25rem
      .guest-name
        font-size 0.28rem
        color #333333
        span
          display inline-block
          width 0.02rem
          height 0.2rem
          background #c8161d
          margin-right 0.1rem
      .guest-title
        font-size 0.26rem
        color #666666
        margin-top 0.2rem
        margin-bottom 0.1rem
        width: 100%
      .guest-desc
        font-size 0.22rem
        color #666666
        line-height 0.36rem
        text-align left
        display -webkit-box
        height: 1.12rem
        overflow hidden
        text-overflow ellipsis
        word-break break-word
        -webkit-box-orient vertical
        -webkit-line-clamp 3
  >>>.van-sticky
    box-shadow 0 .04rem .1rem 0 rgba(0, 0, 0, 0.1)
  >>>.van-tabs__nav--line
    padding 0 0.4rem
    .van-tab
      margin-right 0.28rem
      padding-bottom 0.12rem
      &.van-tab--active
        position relative
        &::before
          content ''
          position absolute
          bottom 0.17rem
          width 100%
          border-bottom 0.02rem solid #c8161d
    .van-tabs__line
      width 0
      height 0
</style>